var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#ABD0CB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_1225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_1225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1013.13 1197.32C1010.1 1199.48 1006.63 1201.65 1003.6 1203.82C1000.13 1205.98 997.099 1208.15 993.633 1209.88C990.599 1211.62 987.999 1213.35 984.966 1215.08C984.533 1215.52 984.099 1215.52 983.666 1215.95C973.699 1222.02 963.299 1227.65 952.899 1232.85C949.866 1234.58 946.399 1236.32 943.366 1237.62C943.366 1237.62 942.933 1238.05 942.499 1238.05C939.033 1239.78 935.566 1241.52 932.099 1243.25C925.166 1246.72 917.799 1249.75 910.866 1252.78C907.399 1254.52 903.499 1255.82 900.033 1257.12C896.566 1258.42 892.666 1260.15 889.199 1261.45C885.733 1262.75 881.833 1264.48 878.366 1265.78C878.366 1265.78 878.366 1265.78 877.933 1265.78C874.466 1267.08 870.566 1268.38 867.099 1269.68C859.299 1272.28 851.066 1274.88 843.266 1277.48C840.666 1278.35 837.633 1279.22 835.033 1280.08C826.799 1282.68 818.566 1284.85 810.333 1286.58C807.299 1287.45 804.266 1287.88 800.799 1288.75C792.999 1290.48 784.766 1292.22 776.966 1293.95C775.233 1294.38 773.933 1294.38 772.199 1294.82C769.599 1295.25 766.566 1295.68 763.966 1296.12C760.066 1296.55 756.599 1297.42 752.699 1297.85C750.966 1298.28 749.233 1298.28 747.499 1298.72C745.333 1299.15 742.733 1299.58 740.133 1299.58C733.199 1300.45 725.833 1301.32 718.899 1302.18C716.733 1302.62 714.133 1302.62 711.966 1303.05H711.533C708.499 1303.48 705.466 1303.48 702.433 1303.92C699.399 1304.35 696.366 1304.35 693.333 1304.35C691.599 1304.35 689.433 1304.78 687.699 1304.78C684.233 1304.78 681.199 1305.22 678.166 1305.22C673.833 1305.22 669.933 1305.65 665.599 1305.65C661.266 1305.65 657.366 1305.65 653.033 1305.65C649.999 1305.65 646.966 1305.65 643.933 1305.65C461.499 1303.05 296.833 1225.48 179.833 1102.42C179.833 1102.42 179.833 1101.98 179.399 1101.98C192.833 1075.55 242.666 1027.88 294.666 988.45C360.533 938.617 453.699 907.85 453.699 907.85C453.699 907.85 514.799 897.884 741.433 945.117C914.333 981.517 987.999 1129.28 1013.13 1197.32Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.533 1065.15C780.433 1109.78 721.499 1136.22 622.266 1096.35C500.499 1046.95 453.699 907.85 453.699 907.85C447.199 808.184 432.033 722.817 432.033 722.817C572.866 710.684 739.266 875.35 739.266 875.35L758.333 956.817C760.066 963.75 763.533 969.817 768.733 974.15C777.833 989.75 795.599 1036.55 789.533 1065.15Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.733 974.584C685.966 970.25 624.866 958.117 559.433 840.684C614.899 889.651 680.333 908.284 749.233 916.95L758.333 956.817C760.066 964.184 763.533 970.25 768.733 974.584Z",
    fill: "#EFBD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.899 452.417C947.699 488.817 951.599 518.284 930.366 615.35C909.133 712.417 949.866 809.484 847.599 898.317C778.699 958.117 658.233 969.384 562.033 903.95C529.533 881.85 499.633 851.084 475.366 810.784C456.299 779.15 434.199 749.25 409.499 721.95C375.266 684.684 334.099 609.717 354.466 477.117C387.399 261.317 601.033 236.617 727.133 260.45C853.233 284.284 918.666 356.217 939.899 452.417Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.199 621.85C525.199 621.85 511.766 556.85 448.499 564.65C393.899 571.584 374.833 702.45 498.766 738.85",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.866 679.483C494.866 679.483 479.266 669.517 480.999 652.183C483.599 631.817 480.999 619.25 471.466 615.35C447.633 605.383 442.866 633.117 443.733 636.583",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.5 721.517C825.5 721.517 841.966 722.384 857.566 703.75C866.233 693.35 873.6 680.35 868.833 676.45C864.066 672.117 785.633 684.25 780.433 694.65C775.233 705.05 805.566 721.517 825.5 721.517Z",
    fill: "#EFBD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.499 575.917C838.499 575.917 839.366 617.084 865.799 663.017C877.499 683.384 859.733 716.75 821.166 722.384",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.533 816.417C906.533 816.85 906.533 816.85 906.533 816.417C906.099 816.85 906.099 816.85 906.533 816.417C895.699 844.583 877.933 871.45 847.599 897.883C778.699 957.683 658.233 968.95 562.033 903.517C551.199 896.15 540.799 887.917 530.833 878.817C523.899 870.15 517.833 861.05 512.633 851.517C481.433 793.017 494.866 738.417 494.866 738.417C494.866 738.417 512.633 738.85 533.866 780.45C551.633 815.117 620.099 813.817 648.266 748.817C679.466 676.45 757.466 708.083 775.233 715.017C792.999 721.95 820.733 721.95 820.733 721.95C890.933 721.083 869.699 768.317 877.066 794.317C887.899 829.85 906.533 816.417 906.533 816.417Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.78 1116.61C996.251 1037.31 900.918 1004.37 848.484 984.873C844.151 963.206 835.918 939.373 822.918 916.406C802.984 928.54 780.018 937.64 756.184 942.406L759.651 956.706C761.384 963.64 770.051 995.706 756.618 1036.87C745.351 1071.54 699.851 1087.14 622.718 1052.04C472.351 984.006 455.018 907.306 455.018 907.306C452.418 865.706 448.084 826.706 444.184 795.073C397.384 805.473 343.218 826.706 313.751 871.34C277.351 925.94 263.918 981.406 267.384 1025.61C204.118 1065.91 106.184 1127.01 74.1176 1236.21C32.5176 1378.34 39.4509 1465.44 39.4509 1465.44H1159.18C1157.88 1465.87 1141.42 1224.51 1057.78 1116.61Z",
    fill: "#6060D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.283 974.473C388.283 974.473 414.717 1077.17 530.417 1148.24",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.05 984.873C848.05 984.873 878.817 1117.91 811.65 1179.01",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.184 1158.64C639.184 1158.64 616.65 1224.51 622.717 1270.01",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.417 1154.74C777.417 1154.74 794.318 1191.57 806.451 1250.07",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.518 1026.04C266.518 1026.04 302.051 1170.77 513.518 1213.24",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.617 1279.97L607.55 1278.24C600.617 1277.37 595.417 1270.87 596.717 1263.94L603.217 1231.44C604.95 1222.34 613.617 1215.84 622.717 1217.14C631.817 1218.01 639.184 1225.81 639.184 1235.34L639.617 1268.71C639.617 1275.21 633.55 1280.84 626.617 1279.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.518 1260.04L807.318 1266.54C800.384 1269.14 793.018 1264.81 791.718 1257.87L783.918 1225.81C781.751 1216.71 786.518 1207.61 795.618 1204.14C804.284 1201.11 814.251 1205.01 818.151 1213.24L832.451 1243.14C835.484 1249.64 832.451 1257.44 825.518 1260.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.62 1250.07C1016.62 1250.07 1040.88 1386.14 1031.35 1465.87",
    stroke: "#544D4D",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.943 619.439C673.543 619.006 665.743 610.339 666.61 599.939L667.043 587.806C667.476 577.406 676.143 569.606 686.543 570.473C696.943 570.906 704.743 579.573 703.876 589.973L703.443 602.106C703.01 612.073 694.343 619.873 683.943 619.439Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.375 625.939C856.842 625.506 849.475 617.272 849.909 607.739L850.342 596.473C850.775 586.939 859.009 579.573 868.542 580.006C878.075 580.439 885.442 588.672 885.009 598.206L884.575 609.473C884.142 619.006 875.909 626.373 866.375 625.939Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.977 594.306C725.977 594.306 714.71 578.273 695.21 575.239C679.177 572.639 661.41 580.439 658.81 589.539",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.81 598.206C853.81 598.206 853.81 584.339 873.743 584.339C890.21 584.339 897.143 599.506 897.143 599.506",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.743 524.539C752.843 527.572 761.942 519.339 760.209 509.372C759.342 504.172 757.176 498.972 752.843 495.072C739.843 483.372 686.109 472.973 653.609 488.139C625.009 502.006 702.143 510.672 743.743 524.539Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.308 531.473C865.941 534.073 858.141 526.273 859.441 517.173C859.875 512.406 861.608 507.639 865.075 504.173C875.475 493.773 911.008 485.539 933.541 501.573C953.041 515.006 907.108 518.906 873.308 531.473Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.016 771.848C800.45 778.781 795.25 790.915 785.716 799.581C736.75 769.681 714.65 785.281 714.65 785.281C697.316 758.848 701.216 722.881 743.25 750.181C772.716 768.815 790.483 771.848 800.016 771.848Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.717 799.581C775.317 808.681 759.717 814.315 738.483 805.648C728.517 801.748 720.717 793.948 714.65 785.281C714.65 785.281 736.75 769.681 785.717 799.581Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.25 770.115C808.25 770.115 790.05 780.081 743.25 750.181C687.35 714.215 698.617 789.615 738.05 805.648C779.217 822.548 800.45 785.715 800.017 771.848",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.65 785.281C714.65 785.281 736.75 769.681 785.717 799.581",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.249 445.323C945.949 438.823 944.216 431.89 942.049 425.39C939.883 418.89 934.683 413.257 927.749 411.957C905.216 408.057 883.549 369.057 852.349 364.723C753.116 351.29 686.816 359.523 593.649 395.923C497.449 433.19 600.583 567.957 531.683 612.157C528.216 600.023 511.316 550.623 455.849 557.557C403.416 564.057 383.483 685.39 491.816 726.99C444.583 804.123 448.049 773.357 413.383 731.757C378.716 690.157 309.383 582.257 356.183 424.523C402.983 266.79 614.883 184.457 812.049 264.623C845.849 278.49 866.216 312.723 895.683 318.357C1169.98 370.79 953.749 476.523 947.249 445.323Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.749 363.423C680.749 363.423 643.916 352.59 621.816 410.223C599.716 467.857 522.583 547.157 458.449 454.857C394.316 362.99 490.516 289.323 590.616 319.223C690.716 349.123 679.449 326.59 680.749 363.423Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.449 321.39C744.449 321.39 841.949 383.357 906.083 359.09C946.383 343.924 991.883 288.024 960.249 246.424C922.549 196.59 805.983 234.29 740.983 213.49C643.483 182.29 492.249 161.49 421.183 278.49C403.416 307.957 387.383 337.857 362.249 361.257C336.249 385.524 310.249 424.957 308.083 486.49C304.183 609.124 400.383 715.724 400.383 715.724C400.383 715.724 343.183 505.99 451.083 474.79C558.983 443.59 588.883 335.69 660.383 335.69C731.883 335.69 698.516 255.09 744.449 321.39Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.35 376.424C839.35 376.424 917.783 474.357 976.716 468.724C1035.65 463.09 1101.95 336.557 939.883 293.224C777.816 249.89 839.35 376.424 839.35 376.424Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.749 363.423C680.749 363.423 732.316 490.823 869.249 505.99C1006.62 521.59 1062.08 270.257 852.349 246.423C642.616 222.59 680.749 363.423 680.749 363.423Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.116 303.624C571.116 303.624 603.183 449.224 670.783 455.724C738.383 462.224 720.183 274.157 631.783 261.157C543.383 248.157 571.116 303.624 571.116 303.624Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M747.932 670.912C747.932 670.912 707.199 696.479 661.266 696.045C615.332 695.612 609.699 659.645 609.266 640.145C609.266 640.145 615.332 668.312 643.066 678.712C670.366 689.112 747.932 670.912 747.932 670.912Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M878.799 666.145C878.799 666.145 888.765 678.279 902.199 686.945C911.299 693.012 923.432 686.512 923.432 675.679C923.866 675.679 898.299 676.979 878.799 666.145Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M763.966 548.279L636.566 675.679C646.533 681.746 658.666 684.779 670.799 683.046L731.466 675.246C749.666 672.646 766.566 663.546 779.566 648.379C784.766 642.746 787.799 634.946 788.233 626.712L790.399 583.812C791.266 565.179 779.566 549.579 763.966 548.279Z",
    fill: "#F6FFFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M763.967 548.279L642.2 537.012C621.833 535.279 604.5 553.912 604.5 577.312V614.145C604.5 641.012 617.5 663.979 636.567 675.679L763.967 548.279Z",
    fill: "#F6FFFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M941.632 543.945L865.365 553.912C855.399 555.212 848.032 569.512 848.899 585.979L850.199 624.545C850.632 631.912 852.366 638.845 855.399 644.045C860.599 652.712 867.099 659.212 874.032 663.545L964.599 572.979C962.866 555.645 952.899 542.645 941.632 543.945Z",
    fill: "#F6FFFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M874.466 663.979C878.366 666.146 881.833 667.879 886.166 668.746L923.866 676.112C945.966 680.446 965.466 651.412 965.466 613.712V580.779C965.466 578.179 965.466 576.012 965.032 573.846L874.466 663.979Z",
    fill: "#F6FFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.967 548.279L642.2 537.012C621.833 535.279 604.5 553.912 604.5 577.312V614.145C604.5 655.745 635.7 687.812 670.8 683.045L731.467 675.245C749.667 672.645 766.567 663.545 779.567 648.379C784.767 642.745 787.8 634.945 788.233 626.712L790.4 583.812C791.267 565.179 779.567 549.579 763.967 548.279Z",
    stroke: "#423232",
    strokeWidth: 14.0292,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.799 554.345L942.066 544.379C954.632 542.645 965.466 559.545 965.466 580.779V613.712C965.466 650.979 945.965 680.012 923.866 676.112L886.166 668.745C874.899 666.578 864.066 657.912 856.266 644.479C853.232 639.279 851.066 632.345 851.066 624.979L849.766 586.412C848.466 569.945 855.832 555.645 865.799 554.345Z",
    stroke: "#423232",
    strokeWidth: 14.0292,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.499 581.645L504.399 579.479",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.399 584.679C790.399 584.679 842.833 574.279 849.333 584.679",
    stroke: "#423232",
    strokeWidth: 14.0292,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy2);
export default __webpack_public_path__ + "static/media/Boy_2.0302495c395dacf6f29f009319be792a.svg";
export { ForwardRef as ReactComponent };